import { render, staticRenderFns } from "./SignUpCard.vue?vue&type=template&id=bbb328ba"
import script from "./SignUpCard.vue?vue&type=script&lang=js"
export * from "./SignUpCard.vue?vue&type=script&lang=js"
import style0 from "./SignUpCard.vue?vue&type=style&index=0&id=bbb328ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports